import { PsychiatricIcon } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../../translations';

import { ModuleChip } from './base/ModuleChip';

const t = dashboardTranslationKeys.neurologicalModule;

export const NeurologicalModuleChip = (): JSX.Element => {
   return <ModuleChip label={t.neurological} icon={<PsychiatricIcon />} testId={'neurologicalModuleChip'} />;
};
